import { API_URL } from "../../utils/contextHelpers";
import { api } from "./core";

export const recuperarCotizacion = api("recuperarCotizacion", (almacen, cliente) => `${API_URL}cotizacion/recuperar?almacen=${encodeURIComponent(almacen)}&cliente=${encodeURIComponent(cliente)}`);

export const agregarCarroProducto = api("agregarCarroProducto", (cantidad, codigo, cotizacion) => `${API_URL}cotizacion/agregar/carro/producto?cantidad=${encodeURIComponent(cantidad)}&codigo=${encodeURIComponent(codigo)}&cotizacion=${encodeURIComponent(cotizacion)}`);